"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var className = function className(props) {
  return (0, _classnames.default)('dbi', "dbi-".concat(props.name), {
    'dbi-lg': props.size === 'lg',
    'dbi-2x': props.size === '2x'
  }, props.className);
};

var Icon = function Icon(props) {
  var name = props.name,
      bold = props.bold,
      size = props.size,
      vOffset = props.vOffset,
      rest = _objectWithoutProperties(props, ["name", "bold", "size", "vOffset"]);

  return _react.default.createElement("i", _extends({}, rest, {
    className: className(props),
    style: {
      position: 'relative',
      fontWeight: bold ? 'bold' : 'normal',
      top: "".concat(vOffset, "px")
    }
  }));
};

var _default = Icon;
exports.default = _default;